import styled, { css } from 'styled-components';
import { mix } from 'polished';
import { focusVisible } from '@cld/style-utils';
import theme, { combineValues } from '@cld/theme-helper';
import { Icon } from '@cld/icon';
import './Checkbox.theme';

const t = theme({ basePath: 'components.checkbox' });

export const StyledIcon = styled(Icon)`
  margin-left: -${t`width`};
`;

export interface RootProps {
  isChecked: boolean;
  isDisabled?: boolean;
  hasError?: boolean;
}

export const Root = styled.div<RootProps>`
  width: ${t`width`};
  height: ${t`height`};
  display: inline-block;
  flex-shrink: 0;
  
  input {
    -webkit-appearance: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
    
    border-radius: ${t`border.radius`};
    transition: 125ms;
    
    border: 1px solid;
    border-color: ${t`border.color.inactive`};
    background-color: ${t`background.color.inactive`};
    
    outline: none;
    &${focusVisible()} {
      outline: none;
      box-shadow: ${t`focus.boxShadow.sizes`} ${combineValues(t`focus.boxShadow.color`, theme`palette.contrastInvert`, (color, contrastColor) =>
  mix(0.5, color, contrastColor)
)} ;
    }
    
    &:hover {
      ${({ hasError, isDisabled }: RootProps) =>
        !hasError &&
        !isDisabled &&
        css`
        border-color ${t`border.color.hover`};
      `}
    }
  }
  
  ${StyledIcon} {
    pointer-events: none;
    color: ${t`icon.color.inactive`};
    transform: scale(0);
    transition: transform 200ms cubic-bezier(.68,1.51,.68,1.51);
    padding: ${t`icon.padding`};
  }
  
  input:checked {
    ${({ hasError, isDisabled }) =>
      !hasError &&
      !isDisabled &&
      css`
        border-color: ${t`border.color.checked`};
        background-color: ${t`background.color.checked`};
      `}
    
    + ${StyledIcon} {
      color: ${t`icon.color.checked`};
      transform: scale(1);
    }
  }
  
  ${({ hasError }) =>
    hasError &&
    css`
      input {
        border-color: ${t`border.color.error`};
        background-color: ${t`background.color.inactive`};
        &:checked {
          background-color: ${t`background.color.error`};
        }

        + ${StyledIcon} {
          color: ${t`icon.color.error`};
        }
      }
    `}
  
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      input {
        border-color: ${t`border.color.disabled`};
        background-color: ${t`background.color.inactive`};
        &:checked {
          background-color: ${t`background.color.disabled`};
        }

        + ${StyledIcon} {
          color: ${t`icon.color.disabled`};
        }
      }
    `}
`;
